import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitleDefault from '../default/DialogTitleDefault';
import { Box, Divider, Grid, Stack, Typography, useTheme } from '@mui/material';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import { ButtonBasic, InputReadQuill } from '../../components';

const Field = ({ label, value, isDarkMode }) => (
    <Box sx={{ mb: 1 }}>
        <Typography sx={{ fontSize: 11, color: isDarkMode ? '#9aa8be' : '#777', textTransform: 'uppercase', fontWeight: 'bold' }}>
            {label}
        </Typography>
        <Typography sx={{ fontSize: 14, color: isDarkMode ? '#fff' : '#222' }}>
            {value || '-'}
        </Typography>
    </Box>
);

const ModalPreviewTicketDebitoRechazado = ({ show, hideModal, row, template }) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const handleClose = () => hideModal();

    const nombre = row?.nombre || '-';
    const contrato = row?.contrato || '-';
    const cuenta = row?.cuenta || '-';
    const email = row?.email || '-';
    const motivo = row?.motivo || '-';

    const cuerpoHtml = template?.cuerpo_mt
        ? template.cuerpo_mt.replaceAll('{{MOTIVO_RECHAZO}}', `<strong>${motivo}</strong>`).replaceAll('SI/NO','SI')
        : null;
    const tipoTicket = template?.tipoTicket?.nombre || 'Administrativo / Cobranzas';
    const grupo = template?.grupo?.nombre || '-';

    return (
        <Dialog open={show} disableEscapeKeyDown maxWidth='sm' fullWidth>
            <Box sx={{ background: isDarkMode ? '#1F2A40' : '#fff' }}>
                <DialogTitleDefault id='preview-ticket-debito' onClose={handleClose}>
                    <Stack direction='row' alignItems='center' spacing={1} sx={{ flex: 1 }}>
                        <ConfirmationNumberIcon sx={{ color: '#7b1fa2' }} />
                        <Typography sx={{ color: isDarkMode ? '#fff' : '#000', fontWeight: 'bold' }} variant='h6'>
                            Vista previa del Ticket
                        </Typography>
                    </Stack>
                </DialogTitleDefault>
                <Divider sx={{ background: isDarkMode ? '#3d4a62' : 'gray' }} />
                <DialogContent sx={{ background: isDarkMode ? '#0f1626' : '#eef2f7', py: 3 }}>
                    <Box
                        sx={{
                            background: isDarkMode ? '#1F2A40' : '#fff',
                            borderRadius: 2,
                            border: `1px solid ${isDarkMode ? '#3d4a62' : '#e0e0e0'}`,
                            overflow: 'hidden',
                            boxShadow: '0 4px 14px rgba(0,0,0,0.12)',
                        }}
                    >
                        <Box sx={{ background: '#7b1fa2', color: '#fff', px: 3, py: 2 }}>
                            <Typography sx={{ fontSize: 12, opacity: 0.85 }}>Nuevo Ticket</Typography>
                            <Typography sx={{ fontSize: 16, fontWeight: 'bold' }}>
                                BAJA DÉBITO AUTOMÁTICO – DÉBITO RECHAZADO
                            </Typography>
                        </Box>

                        <Box sx={{ px: 3, py: 2 }}>
                            <Grid container spacing={1}>
                                <Grid item xs={6}>
                                    <Field label='Cliente' value={nombre} isDarkMode={isDarkMode} />
                                </Grid>
                                <Grid item xs={6}>
                                    <Field label='Email' value={email} isDarkMode={isDarkMode} />
                                </Grid>
                                <Grid item xs={6}>
                                    <Field label='Cuenta' value={cuenta} isDarkMode={isDarkMode} />
                                </Grid>
                                <Grid item xs={6}>
                                    <Field label='Contrato' value={contrato} isDarkMode={isDarkMode} />
                                </Grid>
                                <Grid item xs={6}>
                                    <Field label='Tipo de Ticket' value={tipoTicket} isDarkMode={isDarkMode} />
                                </Grid>
                                <Grid item xs={6}>
                                    <Field label='Grupo' value={grupo} isDarkMode={isDarkMode} />
                                </Grid>
                            </Grid>

                            <Divider sx={{ my: 1.5, borderColor: isDarkMode ? '#3d4a62' : '#eee' }} />

                            <Typography sx={{ fontSize: 11, color: isDarkMode ? '#9aa8be' : '#777', textTransform: 'uppercase', fontWeight: 'bold', mb: 0.5 }}>
                                Descripción
                            </Typography>
                            <Box
                                sx={{
                                    background: isDarkMode ? '#253147' : '#fafafa',
                                    border: `1px solid ${isDarkMode ? '#3d4a62' : '#eee'}`,
                                    borderRadius: 1.5,
                                    p: 1.5,
                                    fontSize: 13,
                                    color: isDarkMode ? '#fff' : '#222',
                                }}
                            >
                                {cuerpoHtml ? (
                                  <Box sx={{background: isDarkMode ? '#e6f0ff' : '#fff', borderRadius: 2}}>
                                    <InputReadQuill
                                      id="cuerpo_html"
                                      template={cuerpoHtml}
                                    />
                                  </Box>
                                ) : (
                                    <Typography sx={{ fontSize: 13, color: '#999', fontStyle: 'italic' }}>Sin template disponible.</Typography>
                                )}
                            </Box>
                        </Box>
                    </Box>
                </DialogContent>
                <Divider sx={{ background: isDarkMode ? '#3d4a62' : 'gray' }} />
                <DialogActions sx={{ p: 2 }}>
                    <ButtonBasic textButton='Cerrar' variant='outlined' color='inherit' onClick={handleClose} />
                </DialogActions>
            </Box>
        </Dialog>
    );
};

export default ModalPreviewTicketDebitoRechazado;
